(ns web3.re-frame.interceptors
  (:require [re-frame.core :as rf]
            [web3.log :as log :include-macros true]
            [web3.utils :as utils :include-macros true]))

(defonce mixpanel-blacklist (atom #{:web3.re-frame.async/delayed-fx
                                    :do/render
                                    :do/boot}))

(def event-transformers
  {:routing/nav #(->> % first (assoc {} :to-url))
   :routing/handle #(->> % first (utils/map-vals :path))})

(defn event->value
  [k v]
  (let [t-fn (get event-transformers k identity)]
    (t-fn v)))


;; ========== Context Manipulation ==========

(defn update-interceptor-queue
  [f context]
  (update context :queue
          (fn [queue]
            (->> queue
                 (map f)
                 (into #queue [])))))

(defn wrap-handler
  [f context]
  (->> context
       (update-interceptor-queue (fn [{:keys [id] :as interceptor}]
                                   (if (= :fx-handler id)
                                     (update interceptor :before f)
                                     interceptor)))))

;; ========== Interceptors ==========

(defn log-event-errors
  [context handler]
  (fn [& args]
    (try (apply handler args)
         (catch :default e
           (do

             (log/group-start :warn (str "Error caught in event: " (first (get-in context [:coeffects :event]))))
             (log/log :error
                      (get-in context [:coeffects :event]))
             (log/log :error
                      "stack" (.-stack e))
             (log/log :error "async flows"
                      (get-in context [:coeffects :db :async-flows]))
             (log/group-end :warn)

             (throw e))))))

(def log-better-errors
  (rf/->interceptor
   :id :log-better-errors
   :before (fn [context]
             (->> context
                  (wrap-handler (fn [handler]
                                  (->> handler
                                       (log-event-errors context))))))))

(defn wrap-error-dispatch
  [context handler]
  (let [k (get-in context [:coeffects :event 0])]
    (fn [& args]
      (try (apply handler args)
           (catch :default e
             (js/setTimeout #(rf/dispatch [:error k e]) 0)
             {})))))

(def dispatch-error
  (rf/->interceptor
   :id :dispatch-on-error
   :before (fn [context]
             (->> context
                  (wrap-handler (partial wrap-error-dispatch context))))))

(def forward-segment-events
  (rf/->interceptor
   :id :forward-to-segment
   :after (fn [ctx]
            (let [event (get-in ctx [:coeffects :event])
                  [k & args] event]
              (when-not (@mixpanel-blacklist k)
                (rf/dispatch [:web3.tracking.segment/event (utils/k->js k) (-> (event->value k args))]))
              ctx))))

;; ========== reg-event ==========

(def base-interceptors
  (->> [log-better-errors
        forward-segment-events]
       (remove nil?)
       (into [])))

(defn reg-event-fx
  ([id handler]
   (reg-event-fx id nil handler))
  ([id interceptors handler]
   (rf/reg-event-fx
    id
    (vec (concat base-interceptors
                 interceptors))
    handler)))

(defn reg-event-db
  ([id handler]
   (reg-event-db id nil handler))
  ([id interceptors handler]
   (rf/reg-event-db
    id
    (vec (concat base-interceptors
                 interceptors))
    handler)))

